export const CREATE_ROOM_ROUTE = {
  TITLE: 'Create Room',
  ABSOLUTE_PATH: '/create-room',
  EXACT_PATH: '/create-room',
  PARENT_PATH: '/create-room/*',
};
